import { TIME_UNITS } from '../../../constants';

export const ENABLE_OTP_LOGIN = 'urn:zillow:email_otp';
export const SUPPORTED_LOGIN_FLAG = 'acr_values';

export const LOCATION_REQUESTED_SESSION_STORAGE_KEY = 'HomeLoansDashboard|SignInRequest|Location';
/**
 * We would not expect to see someone having to log in more than once in 3 minutes. If we detect
 * that to be the case, this could indicate an auth login loop.
 */
export const MINIMUM_EXPECTED_FREQUENCY_SINCE_LAST_SIGN_IN =
    3 * TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS * TIME_UNITS.SECONDS_TO_MILLISECONDS;
